(() => {
  const select = (root, query) => root.querySelector(query);
  const imageClass = 'threeyla-card--master-photo';

  function getVariantId(shell) {
    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;
    const parent = shell.closest('.shopify-section') || document;
    const field = parent.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"]');
    return field?.value || shell.dataset.defaultVariant;
  }

  function syncGallery(shell) {
    const stage = select(shell, '[data-3yla-pdp-stage]');
    const original = select(shell, '[data-3yla-pdp-original]');
    const mapEl = select(shell, '[data-3yla-pdp-variant-map]');
    if (!stage || !original || !mapEl) return;
    let map;
    try { map = JSON.parse(mapEl.textContent); } catch (error) { return; }
    const variantId = getVariantId(shell);
    const photo = map[String(variantId)] || '';
    if (shell.dataset.lastVariant !== String(variantId)) {
      shell.dataset.lastVariant = String(variantId);
      shell.dataset.showOriginal = 'false';
    }
    const showStudio = Boolean(photo) && shell.dataset.showOriginal !== 'true';
    stage.hidden = !showStudio;
    original.hidden = showStudio;
    const backButton = select(shell, '[data-3yla-back-to-studio]');
    if (backButton) backButton.hidden = !photo;
    if (!photo) return;
    const main = select(stage, '[data-3yla-pdp-main]');
    const zoom = select(stage, '[data-3yla-zoom-main]');
    if (main && main.getAttribute('src') !== photo) main.src = photo;
    if (zoom && zoom.getAttribute('src') !== photo) zoom.src = photo;
  }

  function refreshAll() {
    document.querySelectorAll('[data-3yla-pdp-shell]').forEach(syncGallery);
  }

  let scheduled = 0;
  function scheduleRefresh() {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(refreshAll, 160);
    window.setTimeout(refreshAll, 440);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;

    const swatch = button.closest('[data-3yla-card-swatch]');
    if (swatch) {
      const card = swatch.closest('[data-3yla-card]');
      card?.classList.toggle(imageClass, swatch.getAttribute('data-master-photo') === 'true');
    }

    const shell = button.closest('[data-3yla-pdp-shell]');
    if (shell) {
      if (button.matches('[data-3yla-zoom-open]')) {
        shell.querySelector('[data-3yla-pdp-dialog]')?.showModal?.();
        return;
      }
      if (button.matches('[data-3yla-zoom-close]')) {
        shell.querySelector('[data-3yla-pdp-dialog]')?.close?.();
        return;
      }
      if (button.matches('[data-3yla-show-original]')) {
        shell.dataset.showOriginal = 'true';
        syncGallery(shell);
        return;
      }
      if (button.matches('[data-3yla-back-to-studio]')) {
        shell.dataset.showOriginal = 'false';
        syncGallery(shell);
        return;
      }
    }
    scheduleRefresh();
  }, false);

  document.addEventListener('change', scheduleRefresh, true);
  window.addEventListener('popstate', refreshAll);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('DOMContentLoaded', refreshAll);

  if (document.readyState !== 'loading') refreshAll();

  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === Node.ELEMENT_NODE &&
      (node.matches?.('[data-3yla-pdp-shell]') || node.querySelector?.('[data-3yla-pdp-shell]'))))) {
      scheduleRefresh();
    }
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();